export const animalCount = 100;
